import { render } from "./Accounts.vue?vue&type=template&id=39409aa0&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=39409aa0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39409aa0"]])

export default __exports__